import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-c92539b6"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["href"];
const _hoisted_2 = {
  class: "course-cover"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "cover-info"
};
const _hoisted_5 = {
  class: "course-name text-overflow"
};
const _hoisted_6 = {
  class: "teacher-info"
};
const _hoisted_7 = {
  class: "teacher-name text-overflow",
  title: ""
};
const _hoisted_8 = {
  class: "split"
};
const _hoisted_9 = {
  title: "",
  class: "teacher-school text-overflow"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left-line"
}, null, -1));

const _hoisted_11 = {
  class: "course-info"
};
const _hoisted_12 = {
  class: "count-choice"
};
const _hoisted_13 = {
  class: "count"
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 累计选课 ");

const _hoisted_15 = {
  class: "unit"
};

const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 人 ");

const _hoisted_17 = {
  class: "credit-hour"
};
const _hoisted_18 = {
  class: "credit"
};

const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 学分 ");

const _hoisted_20 = {
  class: "unit"
};

const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 学时 ");

const _hoisted_22 = {
  class: "unit"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("a", {
    class: "spoc-course-card",
    href: $props.authType == 2 && !$props.userInfo ? _ctx.$zhsLoginUrl : $props.info.course_url,
    target: "_blank"
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: $data.defaultCover[$options.coverIndex],
    alt: ""
  }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($props.info.course_name), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString($props.info.lecturer), 1), _withDirectives(_createElementVNode("span", _hoisted_8, null, 512), [[_vShow, $props.info.lecturer && $props.info.organ_name]]), _createElementVNode("span", _hoisted_9, _toDisplayString($props.info.organ_name), 1)])]), _hoisted_10]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, [_hoisted_14, _createElementVNode("span", _hoisted_15, _toDisplayString($props.info.students_num || 0), 1), _hoisted_16])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, [_hoisted_19, _createElementVNode("span", _hoisted_20, _toDisplayString($props.info.credit || 0), 1)]), _createElementVNode("span", null, [_hoisted_21, _createElementVNode("span", _hoisted_22, _toDisplayString($props.info.hours || 0), 1)])])])], 8, _hoisted_1);
}